import React from "react";
import {useTranslation} from "react-i18next";
import Notice from "v4/components/ui/Notice/Notice";
import {useAppVersion} from "v4/contexts/AppVersionContext";

export default function AppVersionNotice() {
    const {t} = useTranslation();
    const {updateAvailable} = useAppVersion();

    if (!updateAvailable) {
        return null;
    }

    return (
        <div className="admin__notifications__wrapper notifications__wrapper">
            <Notice
                type="update"
                show={true}
                delay={-1}
                closable={false}
                message={
                    <>
                        <p>{t("new_version_available", "Une nouvelle version est disponible.")}</p>
                        <button type="button"
                                className="btn alertNotice__reload"
                                onClick={() => window.location.reload()}>
                            {t("reload_now", "Recharger")}
                        </button>
                    </>
                }
            />
        </div>
    );
}
